type Word = { url: string; points: number[][]; counter: Map<number, number>; total: number; grids: number[] }

const cache = new Map<string, Promise<Word>>()

export function gridToCoords(grid: number) {
  const u16 = new Uint16Array([grid, grid >> 16]);
  const lon = 5 + ((u16[0] + 0.5) * 15) / 65536;
  const lat = 36 + ((u16[1] + 0.5) * 12) / 65536;

  return { lat, lon };
}

export function loadSingleWordData(url: string): Promise<Word> | null {
  if(!url) return null;

  const cached = cache.get(url)
  if(cached) return cached
  
  const promise = new Promise<Word>((resolve) => {
    return fetch(url).then((response) => response.arrayBuffer())
      .then(buffer => {
        const u32 = new Uint32Array(buffer);

        const points = [];
        const grids = [];
        const counter = new Map<number, number>()

        for (const grid of u32) {
          const {lon, lat} = gridToCoords(grid);
          points.push([lon, lat])
          counter.set(grid, (counter.get(grid) || 0) + 1)
          grids.push(grid)
        }

        resolve({
          url,
          points,
          counter,
          grids,
          total: u32.length,
        })
      })
  })
  cache.set(url, promise)
  return promise
}


export function loadWordData(urls: string[] | string) {
  if(!urls) {
    return []
  } else {

    if(Array.isArray(urls)) {
      return Promise.all(urls.map(loadSingleWordData))
    } else {
      return loadSingleWordData(urls)
    }
  }
}
